export type ServerConfig = {
  API_URL: string
  NIDO_URL: string
  LOG_LEVEL: 'error' | 'warn' | 'info' | 'debug' | 'silent'
  MIXPANEL_TOKEN: string
  NODE_ENV: 'development' | 'test' | 'production'
  SLACK_CLIENT_ID: string
  HTTP_TIMEOUT_MS?: number
  STYTCH_PUBLIC_TOKEN: string | null
  STRIPE_PUBLISHABLE_KEY?: string | null
  STRIPE_PRICING_TABLE_ID?: string | null
  STRIPE_RESUBSCRIBE_PRICING_TABLE_ID?: string | null
  STRIPE_ACCOUNT_ID?: string | null
}

export const KNOWN_SERVERS = [
  'local',
  'production',
  'staging',
  'skatepark',
  'flanders',
  'alex-dev',
] as const

export type KnownServer = (typeof KNOWN_SERVERS)[number]
export type NamedServerConfig = ServerConfig & { name: KnownServer }
